module.exports = "/_next/static/images/mu-d6db35bcfb1ca96b472afaad745a29b3.svg";